export default (model, classes) => {
  let cls = model

  for (const fn of classes) {
    cls = fn(cls)
  }

  return cls
}
